import { errorHandler } from "@helpers/errorHandler";
import { Call } from "@helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "@redux/actions/administrador/ui/ui";
import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

const initialState = {
    active: null,
    openModal: false,
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
};

export const Moodle = createSlice({
    name: "Moodle",
    initialState,
    reducers: {
        setActive: (state, action) => {
            state.active = action.payload;
        },
        clearActive: (state) => {
            state.active = initialState.active;
        },
        setOpenModal: (state, action) => {
            state.openModal = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },
        setList: (state, action) => {
            state.list = action.payload;
        },
        clearList: (state) => {
            state.list = initialState.list;
        },

        clearState: (state) => {
            state = initialState;
        },
    },
});

export const {
    setActive,
    clearActive,
    setOpenModal,
    setPagination,
    clearPagination,
    setList,
    clearList,
    clearState,
} = Moodle.actions;

export default Moodle.reducer;

export const startGetStudent = (values, setErrors = () => {}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const { academic_record_id = null, username = null } = values;

        const resp = await Call(`services/moodle/get/user`, "POST", {
            academic_record_id,
            username,
        });

        if (resp.success) {
            dispatch(setActive(resp.success));
        } else {
            dispatch(clearActive());
            // errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startCreateStudent = (academic_record_id, callback = () => {}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`services/moodle/create/student`, "POST", {
            academic_record_id,
        });

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Alumno registrado en Moodle.",
                icon: "success",
            });
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startCreateTeacher = (teacher_id, callback = () => {}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`teachers/moodle/create`, "POST", {
            teacher_id,
        });

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Docente registrado en Moodle.",
                icon: "success",
            });
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startSyncStudent = (
    academic_record_id,
    username,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`services/moodle/sync/user`, "POST", {
            academic_record_id,
            username,
        });

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Alumno sincronizado con usuario de Moodle.",
                icon: "success",
            });
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startSyncTeacher = (teacher_id, username, callback = () => {}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`teachers/moodle/sync/user`, "POST", {
            teacher_id,
            username,
        });

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Docente sincronizado con usuario de Moodle.",
                icon: "success",
            });
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdateStatus = (values, callback = () => {}, setErrors) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `services/moodle/update/status`,
            "POST",
            values
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                text: `El alumno fue ${
                    suspend ? "suspendido" : "activado"
                } en Moodle.`,
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdateTeacherStatus = (
    values,
    callback = () => {},
    setErrors
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `teachers/moodle/update/status`,
            "POST",
            values
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                text: `El docente fue ${
                    values.suspend ? "suspendido" : "activado"
                } en Moodle.`,
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startGetLoginUrl = (academic_record_id, callback = () => {}) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "Acceso a aulas virtuales",
            text: "Estás por acceder a las aulas virtuales. ¿Deseas continuar?",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
        });

        if (result.isDismissed) return;

        Swal.fire({
            title: "Redireccionando...",
            html: `
                <div class="d-flex flex-column align-items-center">
                    <div class="spinner-border text-primary mb-3" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p>Serás llevado a las aulas virtuales en un momento.</p>
                </div>
            `,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        await new Promise((resolve) => setTimeout(resolve, 1500));

        const resp = await Call(`services/moodle/login-url`, "POST", {
            academic_record_id,
        });

        if (resp.success && resp.success.loginurl) {
            window.open(resp.success.loginurl, "_blank");
            Swal.close();
            callback();
        } else {
            Swal.close();
            errorHandler(resp);
        }
    };
};

export const startGetTeacherLoginUrl = (
    teacher_id,
    callback = () => {}
) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "Acceso a aulas virtuales",
            text: "Estás por acceder a las aulas virtuales. ¿Deseas continuar?",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
        });

        if (result.isDismissed) return;

        Swal.fire({
            title: "Redireccionando...",
            html: `
                <div class="d-flex flex-column align-items-center">
                    <div class="spinner-border text-primary mb-3" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p>Serás llevado a las aulas virtuales en un momento.</p>
                </div>
            `,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        await new Promise((resolve) => setTimeout(resolve, 1500));

        const resp = await Call(`teachers/moodle/login-url`, "POST", {
            teacher_id,
        });

        if (resp.success && resp.success.loginurl) {
            window.open(resp.success.loginurl, "_blank");
            Swal.close();
            callback();
        } else {
            Swal.close();
            errorHandler(resp);
        }
    };
};

export const startGetTeacher = (values, setErrors = () => {}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const { teacher_id = null, username = null } = values;

        const resp = await Call(`teachers/moodle/get/user`, "POST", {
            teacher_id,
            username,
        });

        if (resp.success) {
            dispatch(setActive(resp.success));
        } else {
            dispatch(clearActive());
        }

        dispatch(stopUILoading());
    };
};

export const startSyncCourse = (academic_schedule_id, callback = () => {}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`services/moodle/sync/course`, "POST", {
            academic_schedule_id,
        });

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Horario sincronizado con Moodle.",
                icon: "success",
            });
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startShowMoodleBlocks = ({
    page = 1,
    query = "",
    number_rows = 10,
    asList = 0,
    coordination_ids = [],
    curriculum_ids = [],
    student_status = [],
    status = null,
    from = null,
    to = null,
}) => {
    return async (dispatch) => {
        if (!asList) {
            dispatch(startUILoading());
        }

        const params = new URLSearchParams();

        if (asList) {
            params.set("asList", asList);
        } else {
            params.set("page", page);
            params.set("q", query);
            params.set("per_page", number_rows);
        }

        if (coordination_ids?.length) {
            params.set(
                "coordination_ids",
                coordination_ids.map((item) => item.value).join(",")
            );
        }
        if (curriculum_ids?.length) {
            params.set(
                "curriculum_ids",
                curriculum_ids.map((item) => item.value).join(",")
            );
        }
        if (student_status?.length) {
            params.set(
                "student_status",
                student_status.map((item) => item.value).join(",")
            );
        }
        if (status) {
            params.set("status", status);
        }
        if (from) {
            params.set("from", from);
        }
        if (to) {
            params.set("to", to);
        }

        const resp = await Call(
            `operators/moodle/block/`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setPagination(resp.success));
        } else {
            errorHandler(resp);
        }

        if (!asList) {
            dispatch(stopUILoading());
        }
    };
};
